import { AlertTriangle } from 'lucide-react';
import { GTMProject, STAGE_LABELS } from '../../types/pipeline';

interface Props {
  projects: GTMProject[];
  onRowClick: (p: GTMProject) => void;
}

export function PipelineTable({ projects, onRowClick }: Props) {
  if (projects.length === 0) {
    return <div className="mt-4 text-sm text-neutral-500">No projects match these filters.</div>;
  }
  return (
    <div className="mt-4 overflow-x-auto border border-neutral-200 rounded-md">
      <table className="min-w-full text-sm">
        <thead className="bg-neutral-50 border-b border-neutral-200">
          <tr className="text-left text-2xs uppercase tracking-wide text-neutral-500">
            <th className="px-3 py-2 font-medium">Project</th>
            <th className="px-3 py-2 font-medium">Client</th>
            <th className="px-3 py-2 font-medium">Stage</th>
            <th className="px-3 py-2 font-medium">Flags</th>
            <th className="px-3 py-2 font-medium">Updated</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((p) => (
            <tr
              key={p.id}
              role="button"
              tabIndex={0}
              aria-label={`Open ${p.name}`}
              onClick={() => onRowClick(p)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  if (e.key === ' ') e.preventDefault();
                  onRowClick(p);
                }
              }}
              className="border-b border-neutral-100 last:border-0 hover:bg-neutral-50 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-inset"
            >
              <td className="px-3 py-2 font-medium text-neutral-900">{p.name}</td>
              <td className="px-3 py-2 text-neutral-600">{p.client_entity_name || '—'}</td>
              <td className="px-3 py-2 text-neutral-600">{STAGE_LABELS[p.pipeline_stage]}</td>
              <td className="px-3 py-2">
                {p.needs_human ? (
                  <span
                    className="inline-flex items-center gap-1 text-warning-500 text-xs"
                    title={p.needs_human_reason || 'Needs you'}
                  >
                    <AlertTriangle className="w-3.5 h-3.5" /> Needs you
                  </span>
                ) : null}
              </td>
              <td className="px-3 py-2 text-neutral-500 text-xs">
                {new Date(p.updated_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
